// ３点リーダー

export default function textClamp() {
  $('.js-clamp').each(function () {

    var $target = $(this);
    var rest = "";
    var html = $target.html();
    var $clone = $target.clone();
    var target_height = parseInt($target.css('max-height'));

    $clone
      .css({
        display: 'none',
        'max-height': 'initial'
      })
      .width($target.width())
      .height('auto');
    $clone.addClass("js-ttl-rest");
    $target.after($clone);

    while ((html.length > 0) && ($clone.height() > target_height)) {
      rest = html.substr(html.length - 1, 1) + rest;
      html = html.substr(0, html.length - 1);
      $clone.html(html + "..."); // 高さ更新
    }

    if (rest == "") {
      $target.html(html);
    }
    else {
      $target.html(html + '...');
    }
    $clone.html(rest);
  });
}




// WEBPACK FOOTER //
// ./js/module/textClamp.js